module.exports = __webpack_public_path__ + "static/img/notice_system_migrate.b90f3cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice_system_migrate.jpg
// module id = 1024
// module chunks = 1